import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import BasketMixMobile from "./BasketMixMobile";
import BasketMixDesktop from "./BasketMixDesktop";

function BasketMix({ config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <BasketMixMobile config={config} />
  ) : (
    <BasketMixDesktop config={config} />
  );
}

BasketMix.defaultProps = {
  app: null,
  config: {},
};

BasketMix.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default BasketMix;
